<template>
    <div class="form-container">
        <div class="check-phone-header">
            重置密码
        </div>
        <div class="check-phone-tips">
            请先验证个人资料中绑定的手机号码，如未绑定请联系管理员进行重置。
            <!-- <p v-if="!showAccount">手机号{{ mobile }}绑定了多个企点账号，请选择需要修改密码的账号</p> -->
        </div>

        <v-form kind="desc" class="modifypwd-wrap">
            <v-form-item v-model="phoneNumberErrorMsg" label="手机号" name="phone">
                <v-input
                    ref="defauls"
                    v-model="phoneNumber"
                    :autofocus="true"
                    style="width:345px"
                    placeholder="请填写个人资料中绑定的手机号码"
                    @input="onPhoneInput"
                    @focus="() => (phoneNumberError = false)"
                    @blur="onLoseBlur"
                />
            </v-form-item>

            <v-form-item v-model="phoneVerifyCodeErrorMsg" label="验证码" class="code-input" name="code">
                <v-input
                    ref="glcode"
                    v-model="verifyCode"
                    placeholder="请输入验证码"
                    maxlength="6"
                    @focus="() => (phoneVerifyCodeError = false)"
                />
                <v-button
                    :disabled="!(isPhoneNumber && !codeCountDownIng)"
                    @click="initCaptcha"
                >
                    {{ sendCodeText }}
                </v-button>
            </v-form-item>
            <div
                v-show="errMsg"
                class="error-content"
            >
                <v-icon
                    :style="{color: '#F75559'}"
                    name="v-error"
                    label="提示"
                />
                <span class="error-content-text">{{ errMsg }}</span>
            </div>
            <div class="wrap-cell">
                <v-button
                    :loading="nextStepBtnLoading"
                    status="primary"
                    class="next-step-btn"
                    @click="next"
                >
                    下一步
                </v-button>
            </div>
        </v-form>

        <!-- 图片验证码 -->
    </div>
</template>
<script>
// 请求关联账号list
import { loadResource } from '@tencent/qd-lib';

const GET_AID_URL = '/v1/basic.account.account_web.Account/AidByPhoneV2';

// 发送验证码
const GET_CAPTCHA = '/v1/interface/sendLoginSms';
const TCaptcha = 'https://turing.captcha.qcloud.com/TCaptcha.js';
export default {
    name: 'CheckPhone',
    data() {
        return {
            phoneNumber: '',
            isPhoneNumber: false, // 默认应为false，调试方便改为true
            phoneNumberError: false,
            phoneNumberErrorMsg: '',
            imgCodeShow: false,
            imgCode: '',
            imgCodeError: false,
            imgCodeErrorMsg: '',
            imgCodeBtnLoading: false,
            imgCodeSrc: '',
            codeCountDownIng: false,
            verifyCode: '',
            phoneVerifyCodeError: false, // 默认应为false，调试方便改为true
            phoneVerifyCodeErrorMsg: '',
            sendCodeText: '获取验证码',
            nextStepBtnLoading: false,
            captcha: null,
            errMsg: '',
        };
    },
    created() {
        loadResource(TCaptcha);
    },
    methods: {
        onLoseBlur() {
            if (this.phoneNumber.trim() === '') {
                this.phoneNumber = '';
            }
            if (this.verifyCode.trim() === '') {
                this.verifyCode = '';
            }
            if (this.isPhoneNumber || this.phoneNumber === '') {
                this.phoneNumberError = false;
            } else {
                this.phoneNumberError = true;
                this.phoneNumberErrorMsg = '手机格式错误';
            }
        },
        onPhoneInput() {
            const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (reg.test(this.phoneNumber)) {
                this.isPhoneNumber = true;
            } else {
                this.isPhoneNumber = false;
            }
        },
        loadCaptchaJS(cb) {
            if (window.TencentCaptcha) {
                cb && cb();
            } else {
                loadResource(TCaptcha, () => {
                    cb && cb();
                });
            }
        },
        createCaptcha(initFn, successFn) {
            this.loadCaptchaJS(() => {
                const captcha = new window.TencentCaptcha('2096950042', (res) => {
                    const { ret } = res || {};
                    if (ret === 0) {
                        successFn && successFn(res);
                    }
                });

                initFn && initFn(captcha);
            });
        },
        initCaptcha() {
            this.createCaptcha(
                // 验证码初始化成功回调
                (captcha) => {
                    this.captcha = captcha;
                    this.captcha.show();
                },

                // 验证码验证成功回调
                (res) => {
                    this.sendMsgCode(res);
                },
            );
        },
        sendMsgCode(res) {
            const { ticket, randstr } = res || {};
            if (!this.isPhoneNumber) {
                this.imgCodeError = true;
                this.imgCodeErrorMsg = '请输入正确手机号';
                return;
            }
            const param = {
                uint32_type: 1,
                str_mobile: this.phoneNumber,
                qcloud_captcha: {
                    str_ticket: ticket,
                    str_randstr: randstr,
                },
            };
            this.imgCodeBtnLoading = true;
            this.$ajax.gatewayPost(GET_CAPTCHA, param)
                .then(() => {
                    this.codeCountDownIng = true;
                    this.$refs.glcode.focus();
                    this.codeCountdown();
                })
                .catch((err) => {
                    this.$message.error(err || '发送短信过于频繁，请稍候再试');
                    throw err;
                });
        },
        codeCountdown() {
            let wait = 60;
            const waitText = 's';
            this.sendCodeText = wait + waitText;
            this.timer = setInterval(() => {
                // eslint-disable-next-line no-plusplus
                wait--;
                if (wait < 0) {
                    clearInterval(this.timer);
                    this.codeCountDownIng = false;
                    this.sendCodeText = '获取验证码';
                } else {
                    this.sendCodeText = wait + waitText;
                }
            }, 1000);
            setTimeout(() => {
                this.sendCodeSuccess = true;
            }, 0);
        },
        next() {
            if (this.phoneNumber.trim() === '') {
                this.phoneNumberError = true;
                this.phoneNumberErrorMsg = '请输入手机号';
                return;
            }
            if (!this.isPhoneNumber) {
                this.phoneNumberError = true;
                this.phoneNumberErrorMsg = '手机格式错误';
                return;
            }
            if (this.verifyCode.trim() === '') {
                this.phoneVerifyCodeErrorMsg = '请输入验证码';
                this.phoneVerifyCodeError = true;
                return;
            }
            const params = {
                phone_number: this.phoneNumber,
                sms_code: this.verifyCode,
            };
            this.$ajax.gatewayPost(GET_AID_URL, params).then((res) => {
                if (res && res.code === 0) {
                    this.nextStepBtnLoading = false;
                    const aidList = ((res.data && res.data.aid_corp_info) || []).filter(item => item.aid_status !== 1);
                    if (aidList.length > 1) {
                        this.$emit('phoneInfo', {
                            aidList: aidList.filter(item => !item.aidType),
                            phoneNumber: this.phoneNumber,
                            verifyCode: this.verifyCode,
                        });
                    } else if (aidList.length === 1) {
                        const info = aidList[0];
                        if (info.aid_status === 2) {
                            this.errMsg = '此账号存在违规行为，已被封禁，请联系管理员';
                        } else if (info.aid_status === 3) {
                            this.errMsg = '此账号已被管理员停用，请联系管理员恢复';
                        } else {
                            this.$emit('phoneInfo', {
                                aidList: aidList.filter(item => !item.aidType),
                                phoneNumber: this.phoneNumber,
                                verifyCode: this.verifyCode,
                            });
                        }
                    } else {
                        this.phoneNumberError = true;
                        this.phoneNumberErrorMsg = '手机号不存在，请联系企业管理员重置密码';
                    }
                } else {
                    this.nextStepBtnLoading = false;
                    this.$message.error(res.message || '验证码错误');
                }
            })
                .catch((err) => {
                    this.$message.error(err.message || '验证码错误');
                    this.nextStepBtnLoading = false;
                });
        },
    },
};
</script>
<style lang="less" scoped>
@import '../style.less';

.modifypwd-wrap {
    .wrap-cell {
        text-align: center;
        .input-border {
            .v-button {
                width: 102px;
            }
        }
    }
}
.error-content {
    padding: 0 90px;
    text-align: center;
    color: #F75559;

    &-text {
        display: inline-block;
        height: 20px;
        line-height: 20px;
        vertical-align: top;
    }
}
.img-code-box {
    width: 300px;
    height: 132px;
    background: #ffffff;
    border: 1px solid #dadee7;
    box-shadow: 0px 1px 15px rgba(30, 36, 49, 0.15);
    border-radius: 2px;
    position: relative;
    top: -180px;
    right: -360px;
    .btn-group {
        width: 130px;
        overflow: hidden;
        position: relative;
        padding: 0 20px 20px 143px;
        text-align: left;
        /deep/.v-button--primary {
            min-width: 60px;
            height: 32px;
            font-family: PingFangSC;
            font-size: 14px;
            line-height: 16px;
            text-align: center;
            color: #ffffff;
        }

        /deep/.v-button--default {
            margin-left: 10px;
            min-width: 60px;
            height: 32px;
            font-family: PingFangSC;
            font-size: 14px;
            line-height: 16px;
            text-align: center;
            color: #1e2330;
        }
    }

    .img-code-wrap {
        width: 100%;
        overflow: hidden;
        margin-bottom: 20px;
        position: relative;

        .text-input {
            margin-top: 20px;
            float: left;
            .input-error {
                border-bottom: 2px solid #ff4222;
                /deep/.v-input--default__placeholder {
                    color: #ffffff;
                }
            }

            /deep/.v-input--default {
                margin-left: 20px;
                padding: 0;
                padding-top: 8px;
                width: 104px;
                border: none;
                border-bottom: 1px solid #dadee7;
                .v-input--default__input {
                    font-family: PingFangSC;
                    font-size: 16px;
                    line-height: 19px;
                    color: #1e2330;
                }
            }

            /deep/.v-input--default__placeholder {
                text-align: left;
                letter-spacing: 0;
            }

            /deep/.v-input--default--focus {
                border-bottom: 2px solid #0067ed;
                .v-input--default__placeholder {
                    color: #ffffff;
                    letter-spacing: 0;
                }
            }
        }

        .img-code {
            margin: 20px 20px 0 10px;
            float: left;
            cursor: pointer;
            img {
                width: 96px;
                height: 40px;
            }
            font-family: PingFangSC;
            font-size: 12px;
            line-height: 14px;
            color: #0067ed;
        }
    }
}

.phone-verify-code-tip-show {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #ff4222;
    letter-spacing: 0;
    text-align: right;
    position: absolute;
    right: 120px;
    top: 0;
}

.img-code-error-show {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #ff4222;
    letter-spacing: 0;
    // text-align: right;
    position: absolute;
    left: 20px;
    top: 10px;
}

.img-code-error-hidden {
    position: absolute;
    visibility: hidden;
}
</style>
